import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import skSK from 'antd/locale/sk_SK';
import 'dayjs/locale/sk';
import './sass/style.sass';
import Root from './Root';
import App from "./app/App"

const app = App.instance
const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <GoogleReCaptchaProvider reCaptchaKey="6Leb5bsrAAAAALgEwYPvu3P5Izri4N38t6CEX7VF">
      <ConfigProvider
      locale={skSK}
      theme={{
        token: {
          colorPrimary: '#142654',
          borderRadius: 4,
          colorLink: '#58A617',
          fontFamily: '"Ubuntu", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
        },
      }}
    >
      <BrowserRouter>
        <Root />
      </BrowserRouter>
    </ConfigProvider>
    </GoogleReCaptchaProvider>
  </React.StrictMode>
);
